var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isEqual } from 'lodash';
import { useState, useMemo, useEffect, useCallback } from 'react';
var buildRowState = function (data, props, expandState) {
    if (expandState === void 0) { expandState = false; }
    var recordIdField = props.recordIdField, recordChildrenField = props.recordChildrenField;
    return data.map(function (element) {
        var childNodes = element[recordChildrenField];
        var tempChildNodes = (childNodes === null || childNodes === void 0 ? void 0 : childNodes.length) ? buildRowState(childNodes, props, expandState) : undefined;
        return {
            id: element[recordIdField],
            isExpanded: (tempChildNodes === null || tempChildNodes === void 0 ? void 0 : tempChildNodes.length) ? expandState : false,
            childNodes: tempChildNodes
        };
    });
};
var useExpandAllRow = function (records, tableProps) {
    var _a = tableProps.isDefaultExpandAll, isDefaultExpandAll = _a === void 0 ? false : _a;
    var _b = useState(false), expandState = _b[0], setExpandState = _b[1];
    var _c = useState(function () { return buildRowState(records, tableProps, isDefaultExpandAll); }), rowState = _c[0], setRowState = _c[1];
    var expandAllRows = useMemo(function () { return buildRowState(records, tableProps, true); }, [records, tableProps]);
    var collapseAllRows = useMemo(function () { return buildRowState(records, tableProps); }, [records, tableProps]);
    useEffect(function () {
        setRowState(buildRowState(records, tableProps, isDefaultExpandAll));
    }, [records, tableProps, isDefaultExpandAll]);
    var handleCollapseAllRows = function () {
        setRowState(collapseAllRows);
    };
    var handleExpandAllRows = function () {
        setRowState(expandAllRows);
    };
    var changeExpandStateById = useCallback(function (id, customExpandState, currentRowState) {
        if (currentRowState === void 0) { currentRowState = rowState; }
        setExpandState(false);
        return currentRowState.map(function (row) {
            if (row.id === id) {
                return __assign(__assign({}, row), { isExpanded: customExpandState });
            }
            if (row.childNodes) {
                return __assign(__assign({}, row), { childNodes: changeExpandStateById(id, customExpandState, row.childNodes) });
            }
            return row;
        });
    }, [rowState]);
    var handleChangeExpandStateById = useCallback(function (id, customExpandState) {
        setRowState(changeExpandStateById(id, customExpandState));
    }, [changeExpandStateById]);
    var checkExpandStateById = useCallback(function (id, currentRowState) {
        if (currentRowState === void 0) { currentRowState = rowState; }
        var foundRow = currentRowState.find(function (row) { return row.id === id; });
        if (foundRow) {
            return foundRow.isExpanded;
        }
        return currentRowState.some(function (row) { return row.childNodes && checkExpandStateById(id, row.childNodes); });
    }, [rowState]);
    useEffect(function () {
        setExpandState(isEqual(rowState, expandAllRows));
    }, [expandAllRows, rowState]);
    return {
        expandState: expandState,
        rowState: rowState,
        handleCollapseAllRows: handleCollapseAllRows,
        handleExpandAllRows: handleExpandAllRows,
        changeExpandStateById: handleChangeExpandStateById,
        checkExpandStateById: checkExpandStateById
    };
};
export default useExpandAllRow;
